export default {
  FAVOURITE: "FAVOURITE",
  TAG: "TAG",
  COMPANY: "COMPANY",
  NEW: "NEW",
  TRENDING: "TRENDING",
  NEAR_ME: "NEAR_ME",
  SPEND: "SPEND",
  EARN: "EARN",
  OTHER: "OTHER"
}
